import { Box, Divider, styled } from '@mui/material';

export const StyledGridContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  alignItems: 'center',
  height: theme.spacing(6),
  gridTemplate: `'formulaItems timeTravelButtons deskDivider userLoopBox'`,
  width: '100%',
  gridTemplateColumns: '1fr auto auto auto',
  gap: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    gridTemplate: `'userLoopBox userLoopBox'
                   'formulaItems timeTravelButtons'`,
  },
  [theme.breakpoints.down('md')]: {
    height: theme.spacing(14.5),
    padding: theme.spacing(2),
    gap: theme.spacing(1),
    flexShrink: 0,
  },
}));

export const StyledContainer = styled(Box)(({ theme }) => ({
  gridArea: 'formulaItems',
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.up('md')]: {
    gap: theme.spacing(3),
  },
  [theme.breakpoints.down('md')]: {
    justifyContent: 'space-evenly',
  },
}));

export const StyledWrapper = styled(Box)(({ theme }) => ({
  gridArea: 'timeTravelButtons',
  marginLeft: 'auto',
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    gap: theme.spacing(1),
  },
}));

export const StyledUserLoopWrapper = styled(Box)({
  gridArea: 'userLoopBox',
});

export const StyledDivider = styled(Divider)(({ theme }) => ({
  height: theme.spacing(3),
}));

export const StyledTimeTravelDivider = styled(Divider)(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.down('sm')]: {
    display: 'block',
    height: theme.spacing(3),
  },
}));

export const StyledDeskDivider = styled(Divider)(({ theme }) => ({
  gridArea: 'deskDivider',
  height: theme.spacing(3),
  display: 'block',
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));
